﻿import { axiosInstance } from "../../utils";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useToast } from "@chakra-ui/react";

export type CandidateSignatureDeleteParameter = {
    id: string;
    tenantId: string;
    entityId: string;
    candidateId: string;
};

export function useCandidateSignatureDelete() {
    const axios = axiosInstance();
    const toast = useToast();

    return useMutation({
        mutationFn: (signature: CandidateSignatureDeleteParameter) => {
            return axios
                .delete(`api/Clients/${signature.tenantId}/entities/${signature.entityId}/candidates/${signature.candidateId}/signatures/${signature.id}`)
                .then(response => response.data);
        },
        onSuccess: async () => {
            toast({
                title: "Deleted",
                description: "Signature deleted successfully.",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        },
        onError: error => {
            const axiosError = error as AxiosError;
            toast({
                title: "Unable to delete signature",
                description: `[${axiosError.request.status ?? "ERR"}]: ${axiosError.message}`,
                status: "error",
                isClosable: true,
                duration: null,
            });
        },
    });
}
